<template>
<div>
  <Tables :stickyHeader="true" ref="tableGridLotePago"
        :columns="['Lote','Funcionários Vinculados','Data de inclusão do Lote','Total Gasto', 'Excel', '']"
        :showReload="false"
        v-on:Load="Onload"
        :showButtonNew="true"
        :newHeaderStatus="false"
        :showHeader="true"
        >
        <tr v-for="data in ArrayLotePagos" :key="data.id">
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="data.lote == null ? 'N/D' :  data.lote" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="data.funcionariosVinculados == null ? 'N/D' :  data.funcionariosVinculados" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="formataData(data.dataIncluaoLote == null ? 'N/D' : data.dataIncluaoLote)" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="formatMoney(data.totalGasto == null ? 0 : data.totalGasto)" />
            <td style="font-size:11px; vertical-align:middle;" class="text-center">
              <i class="fas fa-file-excel text-success" style="font-size:16px; cursor:pointer;" @click="baixarExcelLote(data)" v-b-tooltip.hover title="Baixar Excel do lote"></i>
            </td>
            <TableColumn :IsOnlyPedido="!isConsulta && data.codigoEmpresa === 8" v-on:Pedido="showModalPedido(data)" />
          </tr>
  </Tables>

    <b-modal
      centered hide-footer
      title="PEDIDO"
      ref="ModalGerarPedido"
      :no-close-on-backdrop="true"
      size="md"
      >
      <div v-if="PedidoGerado === false">
        <div class="flex">
          <i class="fas fa-file-invoice-dollar icon-pedido">
        </i></div>
        <div class="flex font-label">
          Deseja gerar o pedido ?
        </div>

        <div class="container-buttons-form pt-3">
            <button @click="cancelPedido" class="button-cancel">Cancelar</button>
            <button @click="showModalPedidoGerado" class="button-save">GERAR</button>
        </div>
      </div>
      <div v-if="PedidoGerado === true">
        <div class="flex">
         <i class="fas fa-check-circle icon-pedido iconeSucesso"></i>
        </div>
        <div class="flex font-label">
        Gerado com Sucesso
        </div>

        <div class="flex font-label-menor">
         ORDEM DO PEDIDO
        </div>
        <div class="flex-pedido ">
          <div class="font-label divPedido" v-for="obj in pedido.data.itens" v-bind:key="obj.funcionarioid">
             {{obj.numPedidoGerado}}
          </div>
        </div>

        <div class="container-buttons-form pt-3">
            <button @click="cancelPedido" class="button-cancel">FECHAR</button>
        </div>
      </div>
    </b-modal>
</div>
</template>

<script>
import LotsPaid from './LotsPaid'
export default LotsPaid
</script>

<style scoped>
.divPedido {
  margin: 5px;
  padding: 10px;
  border-radius: 10px;
  background-color: rgb(243, 243, 243);
  height: fit-content;
  width: 7rem;
}
.button-cancel,
.button-save{
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
.button-cancel{
  background-color: #c40000;
  color: white;
}
.button-save{
  background-color: #008148;
  color: white;
}
.container-buttons-form{
  display: flex;
  justify-content: center;
  align-items: center;
  gap:15px;
}
.container-collab{
  justify-content: space-between;
}
.iconeSucesso {
  color: #008148;
}
.flex {
 display: flex;
 justify-content: center;
}
.flex-pedido {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon-pedido{
  font-size: 60px;
  padding: 1rem
}
.font-label-menor{
  padding-top: 1rem;
 font-size: 13px;
}
.font-label{
 font-size: 16px;
 font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/LotsPaid/LotsPaid.vue